<script setup>
import { useScrollStore } from "@/stores/storeScroll";

const storeScroll = useScrollStore();
</script>
<template>
    <div class="main-telegram" :style="{ paddingTop: storeScroll.paddingTop }">
        <div class="main-telegram__container">
            <div class="container">
                <slot></slot>
            </div>
        </div>
    </div>
</template>
<style lang='scss' scoped>
@use '@/assets/scss/base/vars';
.main-telegram {
    &__container {
        padding: 5rem 0;
    }
}
</style>